import React from 'react';
import { DOC_ACCEPT, DOC_MAX_BYTES } from '../shared/transactionDocs';

// Checklist of document uploads shown next to the contract upload. Files are held in `pending` until the
// form saves; `existing` are documents already saved on the deal (they count toward required ones).
export default function DocChecklistUpload({ docs, pending, onChange, existing = [], showErrors, title = 'Required documents' }) {
  if (!docs || !docs.length) return null;
  const setFiles = (key, fileList, multiple) => {
    const files = Array.from(fileList || []);
    const tooBig = files.filter((f) => f.size >= DOC_MAX_BYTES);
    if (tooBig.length) window.alert(`${tooBig.map((f) => f.name).join(', ')} ${tooBig.length === 1 ? 'is' : 'are'} over 25 MB and can't be uploaded.`);
    const ok = files.filter((f) => f.size < DOC_MAX_BYTES);
    onChange({ ...pending, [key]: multiple ? [...(pending[key] || []), ...ok] : ok.slice(0, 1) });
  };
  const removeFile = (key, i) => onChange({ ...pending, [key]: (pending[key] || []).filter((_, n) => n !== i) });
  return (
    <div style={{ margin: '0 0 16px', padding: 12, border: '1px dashed #c9a96e', borderRadius: 6 }}>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>{title}</div>
      {docs.map((d) => {
        const saved = existing.filter((e) => e.category === d.key);
        const files = pending[d.key] || [];
        const has = saved.length + files.length > 0;
        return (
          <div key={d.key} style={{ marginBottom: 10 }}>
            <label style={{ fontSize: 14, fontWeight: 600 }}>
              {d.label} {d.required ? <span style={{ color: '#b00020' }}>*</span> : <span style={{ fontWeight: 400, color: '#7f7f7f' }}>(optional{d.multiple ? ', you can add several files' : ''})</span>}
              <input type="file" accept={DOC_ACCEPT} multiple={!!d.multiple} onChange={(e) => { setFiles(d.key, e.target.files, d.multiple); e.target.value = ''; }} style={{ display: 'block', marginTop: 4, fontSize: 13 }} />
            </label>
            {saved.map((s) => <div key={s.id} style={{ fontSize: 12, color: '#2e7d32' }}>Already on file: {s.name}</div>)}
            {files.map((f, i) => (
              <div key={`${f.name}-${i}`} style={{ fontSize: 12, color: '#5B6270' }}>
                Ready to upload: {f.name} <button type="button" onClick={() => removeFile(d.key, i)} style={{ background: 'none', border: 'none', color: '#b00020', cursor: 'pointer', fontSize: 12 }}>Remove</button>
              </div>
            ))}
            {showErrors && d.required && !has && <div style={{ fontSize: 12, color: '#b00020' }}>Required: please attach this document.</div>}
          </div>
        );
      })}
    </div>
  );
}

// Uploads the pending files to the deal and auto-completes matching collection tasks.
export async function uploadPendingDocs(ownerUid, txId, pending, uploadedBy) {
  const { uploadDealDocument } = await import('../services/dealDocuments');
  const { completeDocTasks } = await import('../services/transactionTasks');
  const done = [];
  for (const [key, files] of Object.entries(pending || {})) {
    for (const file of files || []) { await uploadDealDocument(ownerUid, txId, file, uploadedBy, key); }
    if ((files || []).length) done.push(key);
  }
  if (done.length) await completeDocTasks(txId, done, uploadedBy).catch((e) => console.error('Could not complete document tasks', e));
  return done;
}
